import { useCallback, useState } from 'react';

import { IconButton } from '@ui/components/IconButton';
import { BurgerIcon } from '@ui/icons/BurgerIcon';

import { UserSettingsProps } from '@features/user/hooks/useUserSettings';
import { UserAvatar } from '@features/user/ui/UserAvatar/UserAvatar';
import { UserGameMenuPopover } from '@features/user/ui/UserGameMenu/UserGameMenuPopover';

import styles from './UserGameMenu.module.css';

type Props = {
  user?: {
    userId: string;
    firstName: string;
    lastName: string;
  } | null;
  settings: UserSettingsProps;
  onLogin: () => void;
  onLogout: () => void;
};

export function UserGameMenu({ user, settings, onLogin, onLogout }: Props) {
  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
  const handleLogout = useCallback(() => {
    setIsPopoverOpen(false);
    onLogout();
  }, [onLogout, setIsPopoverOpen]);

  return (
    <div className={styles.userGameMenu}>
      {user ? (
        <UserAvatar size="32" user={user} onClick={() => setIsPopoverOpen(true)} />
      ) : (
        <IconButton preset="hollow" size="32" onClick={() => setIsPopoverOpen(true)}>
          <BurgerIcon />
        </IconButton>
      )}

      <UserGameMenuPopover
        className={styles.userGameMenuPopover}
        user={user ?? undefined}
        onClose={() => setIsPopoverOpen(false)}
        isOpen={isPopoverOpen}
        onLogout={user ? handleLogout : undefined}
        onLogin={user ? undefined : onLogin}
        settings={settings}
      />
    </div>
  );
}
